import client from '../../client';
import {
  GET_CAMPAIGN_DATA,
  GET_CAMPAIGN_DATA_SUCCESS,
  GET_CAMPAIGN_DATA_FAIL
} from '../constants/campaigns';

export const getCampaignData = (params) => dispatch => {
  dispatch({
    type: GET_CAMPAIGN_DATA
  });

  client
    .get('/campaigns', { params })
    .then(res => {
      dispatch({
        type: GET_CAMPAIGN_DATA_SUCCESS,
        data: res.data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_CAMPAIGN_DATA_FAIL,
        error
      })
    });
}



// WEBPACK FOOTER //
// ./src/redux/actions/campaigns.js